import { CHANNEL_INFO_LIST, CHANNEL_INFO_LIST_ERROR, CHANNEL_INFO_LIST_SUCCESS, INTERROGATOR_DETAILS, INTERROGATOR_DETAILS_ERROR, INTERROGATOR_DETAILS_SUCCESS, INTERROGATOR_LIST, INTERROGATOR_LIST_ERROR, INTERROGATOR_LIST_SUCCESS, PIDS_INFO_DETAILS, PIDS_INFO_LIST, PIDS_INFO_LIST_ERROR, PIDS_INFO_LIST_SUCCESS, PIDS_INFO_UPDATE, PIDS_INFO_UPDATE_ERROR, PIDS_INFO_UPDATE_SUCCESS } from './constants';

export default function pidsdata(state, action) {

	let pid_data =[];
	let channel_data =[];
	let interrogators = [];


	switch (action.type) {
      
	case PIDS_INFO_LIST:
		return { ...state, pending: true };
	case PIDS_INFO_LIST_SUCCESS:
		action.payload && action.payload.map((item)=>{
			pid_data.push({
				id: item.id,
				pidsName:item.name,
				ip:item.ipaddress,
				channelcount:item.channelId.length,
				latitude:item.latitude,
				longitude:item.longitude,
				channelId:item.channelId,
				parentAlarmType:item.parentAlarmType ? item.parentAlarmType : 'last',
				waterfallip: item.waterfallip ,
				waterfallport: item.waterfallport ,
				waterfallSocketurl: item.waterfallSocketurl ,
				waterfallSocketurlEnabled: item.waterfallSocketurlEnabled,
				manufacturer: item?.interrogators?.manufacturer ? item?.interrogators?.manufacturer : 'N/A',
				model: item?.interrogators?.model ? item?.interrogators?.model : 'N/A',
				version: item?.interrogators?.version ? item?.interrogators?.version : 'N/A',
				interrogatorsId: item.interrogatorsId ,
			});

		});
		return { ...state, pid_data: pid_data, pending: false };
	case PIDS_INFO_LIST_ERROR:
		return { ...state, error: true };
	case PIDS_INFO_DETAILS:
		return { ...state, details:action.payload, error: true, pending: false };


	case CHANNEL_INFO_LIST:
		return { ...state, pending: true };
	case CHANNEL_INFO_LIST_SUCCESS:
		action.payload && action.payload.map((item)=>{
			channel_data.push({
				id: item.id,
				name:item.name,
				binSize:item.binSize,
				startPos:item.startPos,
				amplitudeNumber:item.amplitudeNumber,
				channelId:item.channelId,
				profile: item.profile
			});
		});
		return { ...state, channel_data: channel_data, pending: false };
	case CHANNEL_INFO_LIST_ERROR:
		return { ...state, error: true, pending: false };

	
	case PIDS_INFO_UPDATE:
		return { ...state, pending: true };
	case PIDS_INFO_UPDATE_SUCCESS:
		return { ...state, update_data: action.payload, pending: false };
	case PIDS_INFO_UPDATE_ERROR:
		return { ...state, error: true, pending: false };

	case INTERROGATOR_LIST:
		return { ...state, pending: true };
		
	case INTERROGATOR_LIST_SUCCESS:
			
		if (action.payload && action.payload.length > 0) {
			action.payload.map( (item) => {
				
				let data = {};
	
				data.id = item.id ? item.id : 0;
				data.manufacturer = item.manufacturer ? item.manufacturer : '';
				data.model = item.model ? item.model : '';
				data.version = item.version ? item.version : '';
				// data.createdAt = item.createdAt ? `${updatedAt.localdate} ${updatedAt.localtime}`  : '';
				// data.updatedAt = item.updatedAt ? item.updatedAt : '';
	
				return interrogators.push(data);
			});
			
			return { ...state, interrogators: interrogators, pending: false, error: false };
		} else {
			if (action.payload && action.payload.length === 0) {
				return { ...state, interrogators: interrogators, pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
		
	case INTERROGATOR_LIST_ERROR:
		return { ...state, pending: false, error: true };
	
	case INTERROGATOR_DETAILS:
		return { ...state, pending: true };
	
	case INTERROGATOR_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };
	
	case INTERROGATOR_DETAILS_ERROR:
		return { ...state, pending: false, error: true };
      
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}